import type { TableCellProps, TypographyProps } from '@mui/material'
import { Tooltip, Typography } from '@mui/material'
import React, { useMemo, useState } from 'react'
import TextTruncate from 'react-text-truncate'
import ParentCellOrFragment from './ParentCellOrFragment'

export type ValueCellProps = {
  value?: string | number
  maxRows?: number
  disableCell?: boolean
  width?: TableCellProps['width']
  disabled?: boolean
} & TypographyProps

const ValueCell: React.FC<ValueCellProps> = ({ value, maxRows = 2, disableCell, width, disabled, ...props }) => {
  const [truncated, setTruncated] = useState(false)

  const displayValue = useMemo(() => value?.toString() || '-', [value])
  const shouldShowTruncate = useMemo(() => value !== null && value !== undefined, [value])

  const handleTruncate = () => {
    setTruncated(true)
  }

  return (
    <ParentCellOrFragment disableCell={disableCell} width={width}>
      <Tooltip title={truncated ? value : undefined}>
        <Typography variant="body1" component="span" color={disabled ? 'textSecondary' : 'textPrimary'} {...props}>
          {shouldShowTruncate ? (
            <TextTruncate line={maxRows} text={displayValue} onTruncated={handleTruncate} />
          ) : (
            displayValue
          )}
        </Typography>
      </Tooltip>
    </ParentCellOrFragment>
  )
}

export default ValueCell
